export interface AdminDashboardKpis {
  aum: number;
  uniqueCustomers: number;
  mraSignedCount: number;
  totalCustomers: number;
  activeCustomers: number;
  amountDueThisMonth: number;
  dueThisMonthCount: number;
  cashflowToAstrafin: number;
  totalOutstanding: number;
  unpaidCount: number;
}

export const EMPTY_ADMIN_DASHBOARD_KPIS: AdminDashboardKpis = {
  aum: 0,
  uniqueCustomers: 0,
  mraSignedCount: 0,
  totalCustomers: 0,
  activeCustomers: 0,
  amountDueThisMonth: 0,
  dueThisMonthCount: 0,
  cashflowToAstrafin: 0,
  totalOutstanding: 0,
  unpaidCount: 0,
};

const num = (value: unknown): number => {
  const n = Number(value);
  return Number.isFinite(n) ? n : 0;
};

const pick = (obj: Record<string, unknown>, camel: string, snake: string) =>
  obj[camel] ?? obj[snake];

/** Normalize GET /rental-schedule/admin-dashboard-kpis */
export function normalizeAdminDashboardKpis(payload: unknown): AdminDashboardKpis {
  const root =
    payload && typeof payload === "object" && "data" in payload
      ? (payload as { data?: unknown }).data
      : payload;

  if (!root || typeof root !== "object") return { ...EMPTY_ADMIN_DASHBOARD_KPIS };

  const raw = root as Record<string, unknown>;
  return {
    aum: num(pick(raw, "aum", "aum")),
    uniqueCustomers: num(pick(raw, "uniqueCustomers", "unique_customers")),
    mraSignedCount: num(pick(raw, "mraSignedCount", "mra_signed_count")),
    totalCustomers: num(pick(raw, "totalCustomers", "total_customers")),
    activeCustomers: num(
      raw.activeCustomers ??
        raw.active_customers ??
        // legacy keys while backend migrates from schedules → customers
        raw.activeSchedules ??
        raw.active_schedules ??
        0
    ),
    amountDueThisMonth: num(pick(raw, "amountDueThisMonth", "amount_due_this_month")),
    dueThisMonthCount: num(pick(raw, "dueThisMonthCount", "due_this_month_count")),
    cashflowToAstrafin: num(pick(raw, "cashflowToAstrafin", "cashflow_to_astrafin")),
    totalOutstanding: num(pick(raw, "totalOutstanding", "total_outstanding")),
    unpaidCount: num(pick(raw, "unpaidCount", "unpaid_count")),
  };
}
